import { supabase } from '../../../config/supabase';
import { AssessmentResultsV2Service } from './AssessmentResultsV2Service';
import type { AssessmentResultV2 } from '../types';
import { isMedicalRecordInvalidated } from '../../../utils/medicalRecordStatus';

/** A RPC é idempotente, respeita RLS e nunca altera uma avaliação existente. */
export class AnamnesisAssessmentLinkService {
  static async ensure(recordId: string, clientId: string, patientId: string): Promise<AssessmentResultV2 | null> {
    if (!recordId || !clientId || !patientId) throw new Error('Identifique a anamnese, a clínica e o paciente.');
    const { data: source, error: sourceError } = await supabase.from('medical_records')
      .select('recordId, recordType, recordAttachments').eq('clientId', clientId)
      .eq('patientId', patientId).eq('recordId', recordId).maybeSingle();
    if (sourceError) throw sourceError;
    if (!source || isMedicalRecordInvalidated(source.recordType, source.recordAttachments)) {
      throw new Error('A anamnese não está ativa no prontuário do paciente selecionado.');
    }
    const { data, error } = await supabase.rpc('ensure_anamnesis_assessment_draft', { p_record_id: recordId });
    if (error) {
      if (error.code === 'PGRST202' || error.code === '42883') {
        throw new Error('A integração da anamnese precisa da atualização do banco de dados desta clínica.');
      }
      throw error;
    }
    if (typeof data !== 'string' || !data) return null;
    const [result] = await AssessmentResultsV2Service.listByIds(clientId, [data]);
    if (!result) throw new Error('A avaliação vinculada não está disponível. Atualize a página.');
    if (result.patientId !== patientId || result.clientId !== clientId) throw new Error('A avaliação vinculada não corresponde ao paciente selecionado.');
    return result;
  }
}
